let API_BASE_URL = '';
let WALLET_API_BASE_URL = '';
let SIGNKEY = '';
let ENSKEY = '';
let IVKEY = '';
let FM_AGREEMENTURL = '';
let channelIdList: string[] = [];
let routerReplaceChannel: string[] = [];
switch (import.meta.env.VITE_USER_NODE_ENV) {
  case 'production':
    API_BASE_URL = 'https://gw-pro-external.youhangjh.com';
    WALLET_API_BASE_URL = 'https://apih5.yocdk.com/';
    SIGNKEY = 'WJxfqrnOZAfL3YBJO8crx5TuKZkzvZCtCI7PPeNPQDGHIC07yY7o34MMJK6B6PN7';
    FM_AGREEMENTURL = 'https://protocol-pro.usurong.com/';
    ENSKEY = 'VdI2yvFx2mJt2ECX';
    IVKEY = 'WK6EdgHihMnpsFJd';
    channelIdList = ['639', '74', '760', '215', '87', '78',
      '796','797','798','799','800','801','802','803','804','805','806','807','808','809','810','811','812','813','814','815','816',
      '817','818','819','820','821','822','823','824','825','826','827','828','829','830','831','832','833','834','835','836','837',
      '838','839','840', '841','842','843','844','845','846','847','848','849','850','851','852','853','854','855','856','857','858',
      '859','860','861','862','863','864','865','866','867','868','869','870', '871','872','873','874','875','876','877','878','879',
      '880','881','882','883','884','885', '886','887','888','889','890','891','892','893','894','895', '464'];
    routerReplaceChannel = ['1161'];
    break;
  case 'test':
    API_BASE_URL = 'https://gw-test-external.youhangjh.com';
    WALLET_API_BASE_URL = 'https://testslbh5.youkawallet.com/';
    SIGNKEY = '9tisVfmYyrZ3rMOhC6aEOaFwBpdrENu4VFXNzVXZzLy2lu79xTY5c07Vxe5bvXVO';
    FM_AGREEMENTURL = 'https://protocol-test.usurong.com/';
    ENSKEY = 'YUnDlSCcyvbhQ0bV';
    IVKEY = 'qBOWS5fNSseXLHuZ';
    channelIdList = ['10', '558'];
    routerReplaceChannel = [];
    break;
  default:
    API_BASE_URL = 'https://gw-test-external.youhangjh.com';
    WALLET_API_BASE_URL = 'https://testslbh5.youkawallet.com/';
    SIGNKEY = '9tisVfmYyrZ3rMOhC6aEOaFwBpdrENu4VFXNzVXZzLy2lu79xTY5c07Vxe5bvXVO';
    FM_AGREEMENTURL = 'https://protocol-test.usurong.com/';
    ENSKEY = 'YUnDlSCcyvbhQ0bV';
    IVKEY = 'qBOWS5fNSseXLHuZ';
    channelIdList = ['10'];
    routerReplaceChannel = [];
}
export {
  API_BASE_URL,
  SIGNKEY,
  ENSKEY,
  IVKEY,
  WALLET_API_BASE_URL,
  FM_AGREEMENTURL,
  channelIdList,
  routerReplaceChannel,
};
